<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>1st G H Raisoni Memorial Jalna International Fide Rapid Rating
                        Chess Tournament </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span>1st G H Raisoni Memorial Jalna International Fide Rapid Rating
                    Chess Tournament </span>
            </h2>
        </div>
        <p><strong>Date:</strong> 8th Feb 2026 </p>
        <p><strong>Venue:</strong> Sri Chaitanya Techno School, Jalna (MH)</p>

        <p>The 1st G. H. Raisoni Memorial Jalna International FIDE Rapid Rating Chess
            Tournament 8
            th February 2025, organized by Kalpana Prakash Welfare Foundation
            in association with G. H. Raisoni and Glorious Chess Academy, was a grand
            success. The event witnessed enthusiastic participation with 245 registered
            players representing federation India (Six different states – BR, GJ, KA, MH, MP
            and TG). The total prize fund was ₹2,00,000/- with the winner receiving ₹31,000/-</p>

        <ul class="list-style list-style1 mb-3  ">
            <li>Mr. Sachin Giri, BDM Shri Chaitanya Techno School. </li>
            <li> Mr. Bhushan Shriwas, Secretary Kalpana Prakash Welfare Foundation
                and Chess Association Nagpur. </li>
            <li>Mr. Satish Thakur, Joint-Secretary Maharashtra Chess Association
                and Director of Glorious Chess Academy. </li>
            <li> Mr. Aasaram Ghule, Representative RTO Office Jalna. </li>
            <li> Mr. Krushna Thakur, Cofounder of Glorious Chess Academy. </li>
            <li> IA Pavan K. Rathi, Indian Book Record Holder and Chief Arbiter of the
                tournament.</li>

        </ul>
        <hr>
        <h5 class="primary-purple"> Dignitaries Present:</h5>
        <ul class="list-style list-style1 mb-3  ">
            <li><strong>C.A. Satish Girdharlal Sarda</strong>
                Managing Partner, Sarda Soni Associates LLP.
                Past Chairam of ICAI Nagpur & WICASA Nagpur
                Past President Orange City Jayceel.</li>
            <li><strong>Smt. Mamta Satish Sarda</strong> – Director (Admin),
                CIFC Private Limited and Director Safal Consultants.</li>
            <li><strong>Shri Bhushan Shriwas,</strong> Secretary Kalpana Prakash
                Welfare Foundation & Chess Association Nagpur</li>
            <li><strong>Shri S.S Soman</strong>
                Working President CAN</li>
            <li>IA Shiva Iyer
                Chief Arbiter</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Tournament Highlights: </h5>
        <ul class="list-style list-style1 mb-3 list-count ">
            <li> FIDE Format: Rapid Rating</li>
            <li> No. of Rounds: 9 Rounds</li>
            <li> Pairing System: Swiss League</li>
            <li> Time Control: 10 Minutes + 05 Seconds Increment From Move 1</li>
            <li>Participants: 245</li>
            <li>Female Player: 41</li>
        </ul>
        <hr>
        <h5 class="primary-purple"> Technical Team: </h5>
        <ul class="">
            <li><strong> Chief Arbiter:</strong> IA Pavan K. Rathi (Indian Book of Record as
                Organiser)</li>
            <li><strong> Dep. Chief:</strong> FA Satish Thakur</li>
            <li> Arbiters:
                <ul class="list-style list-style1 mb-3 list-count ">
                    <li> FA Krishna Thakur </li>
                    <li> FA Amitkumar Tembhurne</li>
                    <li> FA Amrish Joshi</li>
                    <li> SNA Prayas Ambade</li>
                    <li> SNA Shishir Indurkar</li>
                    <li> SNA Pravin Joshi</li>
                    <li> SNA Vilas Rajput</li>
                </ul>
            </li>
            <li>Assistants:
                <ul class="list-style list-style1 mb-3 list-count ">
                    <li>Mr. Sujal Thakur</li>
                    <li>Mr. Vijay Thakur</li>
                    <li>Mr. Vishal Shinde</li>
                    <li>Mr. Sachal Bihani</li>
                </ul>
            </li>
        </ul>
        <hr>

        <h5 class="primary-purple"> Closing Ceremony:
        </h5>

        <ul class="list-style list-style1 mb-3  ">
            <li> Mr. Makarand Shahapurkar, Chief Representative Lokmat Newspaper.</li>
            <li> Mr. Sanjay Deshmukh, Editor Jalna Nayak Newspaper.</li>
            <li> Mr. Sachin Giri, BDM Shri Chaitanya Techno School.</li>
            <li> Mr. Rajkumar Munde, Representative RTO Office Jalna.</li>
            <li> Mr. Bhushan Shriwas, Secretary Kalpana Prakash Welfare Foundation
                and Chess Association Nagpur.</li>
            <li> Mr. Satish Thakur, Joint-Secretary Maharashtra Chess Association
                and Director of Glorious Chess Academy.</li>
            <li> Mr. Aasaram Ghule, Representative RTO Office Jalna.</li>
            <li> Mr. Krushna Thakur, Cofounder of Glorious Chess Academy.</li>
            <li> IA Pavan K. Rathi, Indian Book Record Holder and Chief Arbiter of the
                tournament. </li>
        </ul>

        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-chess-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-chess-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-chess-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-chess.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-chess.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-chess.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Reports</h4>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/jalna-chess/jalna-signature-file.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4>Winner List</h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
